import request from '@apps-common/js-client/api/request';
import {useQuery} from '@tanstack/react-query';
import {removeEmpty} from './util.js';
import {PDA_ADMIN_URL} from '@app/config';

const getOrganizations = ({params, ...options} = {}) => {
  return request
    .get(`${PDA_ADMIN_URL}/organizations/`, {
      ...options,
      params,
    })
    .then(res => res.data);
};

const getOrganization = (orgId, {params, ...options} = {}) => {
  return request
    .get(`${PDA_ADMIN_URL}/organizations/${orgId}`, {
      ...options,
      params,
    })
    .then(res => res.data);
};

const queryKeys = {
  all: ['organizations'],
  lists: () => [...queryKeys.all, 'list'],
  list: filters => [...queryKeys.lists(), removeEmpty({...filters})],
  details: () => [...queryKeys.all, 'detail'],
  detail: id => [...queryKeys.details(), id],
};

export const useGetOrganizations = ({...params} = {}, queryOptions = {}) => {
  const queryParams = {
    state__in: 'active',
    sort: '-id',
    ...params,
  };
  return useQuery({
    queryKey: queryKeys.list(queryParams),
    queryFn: () => getOrganizations({params: queryParams}),
    ...queryOptions,
  });
};

export const useGetOrganization = ({id} = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: queryKeys.detail(id),
    queryFn: () => getOrganization(id),
    ...queryOptions,
  });
};
